// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19fM3","top":"styles_top__dvX3L","left":"styles_left__pL1rk","description":"styles_description__JqgpC"};